import { useTranslation } from "react-i18next";

import { Skeleton, Columns, Column, Spacer, Typography, Box } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@unauthenticated/oauth/locales/i18n";

import * as styles from "./OAuthBankingForm.styles";

const SkeletonOAuthBankingForm = () => {
  const { phoneLarge } = useBreakpoints();
  const { t } = useTranslation("oauth");

  return (
    <>
      <Typography css={styles.blurb}>{t(l.oauth.congratulationsOnBecomingAProfit)}</Typography>
      <Spacer height="double" />

      <Box>
        <Skeleton type="typography" typographySize="h2" margin="bottom" />
        <Skeleton type="typography" typographySize="h4" margin="bottom" />
        <Columns isMultiline>
          <Column columnWidth={6}>
            <Skeleton isFullWidth type="typography" height={3.5} margin="bottom" />
          </Column>
        </Columns>
        <Spacer height="triple" />
      </Box>
      {[0, 1, 2].map(item => (
        <Box key={item}>
          <Skeleton type="typography" typographySize="h2" margin="bottom" />
          <Columns isMultiline>
            {[0, 1, 2, 3].map(num => (
              <Column key={num} columnWidth={6}>
                <Skeleton isFullWidth type="typography" height={3.5} />
              </Column>
            ))}
          </Columns>
          <Spacer height="triple" />
        </Box>
      ))}

      <div css={styles.proceedButtons}>
        <Skeleton type="button" isFullWidth={phoneLarge.lessThan} />
      </div>
    </>
  );
};

export { SkeletonOAuthBankingForm };
